// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.visible-container {
  background-color: #fff;
  color: #000;
  visibility: visible;
  overflow: auto;
  font-size: small;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: 5px;
  position: absolute;
  z-index: 99;
  bottom: 125%;
  left: 35%;
  opacity: 1;
  cursor: text;
}

/* Scrollbar */
.visible-container::-webkit-scrollbar {
  width: 0;
}

/* Track */
.visible-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

/* Handle */
.visible-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* Handle on hover */
.visible-container::-webkit-scrollbar-thumb:hover {
  background: #555;
  border-radius: 5px;
}

.info-table-border {
  border: 1px solid black;
}`, "",{"version":3,"sources":["webpack://./src/components/AppLayout/Footer/Info/index.css"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AACJ;;AACA;EACI,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAEJ;;AACA,cAAA;AACA;EACI,QAAA;AAEJ;;AACA,UAAA;AACA;EACI,mBAAA;EACA,kBAAA;AAEJ;;AACA,WAAA;AACA;EACI,gBAAA;EACA,kBAAA;AAEJ;;AACA,oBAAA;AACA;EACI,gBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ","sourcesContent":[".info-container {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n}\n.visible-container {\n    background-color: #fff;\n    color: #000;\n    visibility: visible;\n    overflow: auto;\n    font-size: small;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    padding: 5px;\n    position: absolute;\n    z-index: 99;\n    bottom: 125%;\n    left: 35%;\n    opacity: 1;\n    cursor: text;\n}\n\n/* Scrollbar */\n.visible-container::-webkit-scrollbar {\n    width: 0;\n}\n\n/* Track */\n.visible-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 5px;\n}\n\n/* Handle */\n.visible-container::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 5px;\n}\n\n/* Handle on hover */\n.visible-container::-webkit-scrollbar-thumb:hover {\n    background: #555;\n    border-radius: 5px;\n}\n\n.info-table-border {\n    border: 1px solid black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
